import React, { isValidElement, JSX, useEffect, useRef, useState } from "react";

import { Button, Table, TableTitleLayout, Tag } from "@shared/ui";

import { Flex, Modal, Rate } from "antd";
import { ColumnsType } from "antd/es/table";
import styles from "./styles.module.scss";

import { dynamicColumnsToShow } from "@entities/discovery/lib/constants";
import { useGetInfluencerStore } from "@entities/discovery/lib/store/useGetInfluencerStore";
import { InfluencerFilters } from "@features/InfluencerFilters/InfluencerFilters";
import { BriefCreatorColumn } from "@features/breifCreatorColumn/BriefCreatorColumn";
import { FilterKeyValueMap } from "@shared/lib/constants";
import {
  DynamicColumnType,
  ICreator,
  IGFilters,
  OtherFilters,
  YtFilters,
} from "@shared/lib/types";
import {
  InfluencerType,
  SocialMediaPlatform,
} from "@shared/lib/types/influencer";
import { formatData } from "@shared/lib/utils/formatData";
import { Checkbox } from "@shared/ui/Checkbox";
import { Footer } from "antd/es/layout/layout";
import { createPortal } from "react-dom";
import { useSearchParams } from "react-router-dom";
import { SearchMultiSelectFilter } from "../filters/SearchMultiSelectFilter";
import ColumnFilterWrapper from "../filters/ColumnFilterWrapper/ColumnFilterWrapper";
import { InfluencerSearchHeader } from "./InfluencerSearchHeader";
import SuggestCampaignForm from "./SuggestCampaignForm";

export function InfluencerTable({
  ButtonComponent,
  TopEditButton,
  isFromBuckePage,
  bucketName,
  bucketId,
  selectedCreators,
  setSelectedCreators,
  isLinked,
}: {
  ButtonComponent: () => JSX.Element;
  TopEditButton: () => JSX.Element;
  isFromBuckePage?: boolean;
  bucketName?: string;
  bucketId?: string;
  selectedCreators?: ICreator[];
  setSelectedCreators?: (cratorsId: ICreator[]) => void;
  isLinked?: boolean;
}) {
  const [paegNo, setPageNo] = useState<number>(1);
  const [pageSize, setPageSize] = useState(10);
  const [feUsername, setFeUserName] = useState<string>("");
  const [isSuggestModalOpen, setSuggestModalOpen] = useState<boolean>(false);

  const [selectedInfluencer, setSelectedInfluencer] = useState<{
    visible: boolean;
    props?: {
      socialMediaDrawerId: string;

      creatorInfo: {
        name?: string;
        image?: string;
        username?: string;
      };
    };
  }>({ visible: false, props: undefined });

  const {
    updateFilters,
    selectedFilters,
    data,
    facets,
    backendFIlters,
    platform,
    username,
    setPlatform,
    setUsername,
    fetchData,
    fetchFacets,
    isLoadingData,
    reset,
    saveFilters,
    resetFilters,
    setFiltersFromUrl,
    fullReset,
  } = useGetInfluencerStore();

  useEffect(() => {
    const timeout = setTimeout(() => {
      const params = new URLSearchParams(searchParams);
    setUsername(feUsername);
    params.set("username", JSON.stringify(feUsername));
    setSearchParams(params);
    fetchData(pageSize, 1, bucketId);
    setPageNo(1);
    setSelectedCreators && setSelectedCreators([]);
    }, 250);
    return () => {clearTimeout(timeout)}
  }, [feUsername]);
  const [searchParams, setSearchParams] = useSearchParams();
  // const [socialMediaDrawerId, setSocialDrawerId] = useState<string>("");
  const category = (backendFIlters?.category as string[]) || [];
  const type = (backendFIlters?.creatorType as InfluencerType[]) || [];
  const location = (backendFIlters?.location as string[]) || [];
  const rating = (backendFIlters?.rating as number) || 0;

  const [showAdvanced, setShowAdvanced] = useState<boolean>(true);

  const categoriesToDisplay =
    (facets?.category || [])?.map((item) => item._id) || [];
  const typeToDisplay =
    (facets?.creatorType || [])?.map((item) => item._id as InfluencerType) ||
    [];

  const locationToDisplay =
    (facets?.location || [])?.map((item) => item._id) || [];

  const handlePaginationChange = (page: number, size: number) => {
    setPageNo(page);
    setPageSize(size);
    fetchData(size, page, bucketId);
    setSelectedCreators && setSelectedCreators([]);
  };

  const handleCategoryChange = (value: string[] | undefined) => {
    if (!value || !value.length) updateFilters("category", undefined);
    else {
      updateFilters("category", value);
    }
    saveFilters();
  };
  const handleTypeChange = (value: InfluencerType[] | undefined) => {
    if (!value || !value.length) updateFilters("creatorType", undefined);
    else {
      updateFilters("creatorType", value);
    }
    saveFilters();
  };
  const handleRatingChange = (value: number | undefined) => {
    if (!value) {
      updateFilters("rating", undefined);
    } else {
      updateFilters("rating", value);
    }

    saveFilters();
  };

  const handleLocationChange = (value: string[] | undefined) => {
    if (!value || !value.length) updateFilters("location", undefined);
    else {
      updateFilters("location", value);
    }
    saveFilters();
    saveFilters();
  };


  const filters =
    platform === SocialMediaPlatform.Instagram
      ? IGFilters
      : platform === SocialMediaPlatform.YouTube
        ? YtFilters
        : OtherFilters;
  const getFacetname = (facetName: string) => {
    return (filters as any[]).find((item) => item.facetName === facetName)?.title || "";
  };

  const getfiltervalue = (
    depth: number,
    data: any,
    insidenames: string[]
  ): string | number => {
    if (depth == 1) {
      return typeof data[insidenames[0]] === "boolean"
        ? data[insidenames[0]]
          ? "True"
          : "False"
        : formatData(data[insidenames[0]]);
    }
    if (depth === 2 && Array.isArray(data[insidenames[0]])) {
      return data[insidenames[0]].join(" ,");
    }
    if (depth === 3) {
      return formatData(
        data[insidenames[0]].find(
          (e: any) =>
            e?.name === insidenames[1] ||
            e?.range === insidenames[1] ||
            e?.value === insidenames[1]
        )?.percentage
      );
    }
    return "";
  };

  const flattenFilters = (
    filters: Record<string, any>
  ): DynamicColumnType[] => {
    const result: DynamicColumnType[] = [];

    Object.entries(filters).forEach(([key, value]) => {
      if (value === null || value === undefined) return;

      const colName = getFacetname(key);
      const mappedKey =
        FilterKeyValueMap[key as keyof typeof FilterKeyValueMap];

      if (
        typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean" ||
        !dynamicColumnsToShow.has(key)
      ) {
        result.push({ colName: colName, depth: 1, insideNames: [mappedKey] });
        return;
      }

      if (Array.isArray(value) && value.length > 0) {
        if (typeof value[0] === "string") {
          result.push({ colName: colName, depth: 2, insideNames: [mappedKey] });
        } else {
          result.push(
            ...value.map((item) => ({
              colName: `${colName} : ${item?.name}`,
              depth: 3,
              insideNames: [mappedKey, item?.name],
            }))
          );
        }
        return;
      }

      result.push({ colName: colName, depth: 1, insideNames: [mappedKey] });
    });

    return result;
  };

  const flattenedFilters = flattenFilters(backendFIlters);

  const dynamicColumns = flattenedFilters.map((item) => {
    return {
      title: item.colName,
      dataIndex: `searchV1.${item.colName}`,
      render: (_: string, record: ICreator) => (
        <div className="grid">
          <div>
            {getfiltervalue(item.depth, record.searchV1, item?.insideNames)}
          </div>
        </div>
      ),
    };
  });

  const rowSelection = {
    selectedRowKeys: selectedCreators?.map((item) => item._id) || [],
    onChange: (_selectedRowKeys: React.Key[], selectedRows: ICreator[]) => {
      if (setSelectedCreators) {
        setSelectedCreators(selectedRows.filter(Boolean));
      }
    },
    renderCell: (checked: boolean, record: ICreator, index: number, originNode: any) => {
      return <Checkbox {...originNode?.props} />;
    },
    columnTitle: (checkboxNode: React.ReactNode) => {
      if (isValidElement(checkboxNode)) {
        return <Checkbox {...(checkboxNode.props as any)} />;
      }
      return checkboxNode;
    },
  };

  const columns: ColumnsType<ICreator> = [
    {
      title: "Name",
      dataIndex: "username",
      key: "name",
      render: (_: string, record: ICreator) => (
        <Flex align="center" gap={10}>
            <BriefCreatorColumn 
              username={record.username}
              profilePicUrl={record.profilePicUrl}
              platform={record.platform}
              influencerName={record.name}
            />
        </Flex>
      ),
    },
    {
      title: "Followers",
      dataIndex: "searchV1.followerCount",
      key: "name",
      render: (_: string, record: ICreator) => (
        <div>
          {new Intl.NumberFormat("en", { notation: "compact" }).format(
            record?.searchV1?.followerCount || 0
          )}
        </div>
      ),
    },
    {
      title: "Avg Reel Views",
      dataIndex: "searchV1.avgReelViews",
      key: "name",
      render: (_: string, record: ICreator) => (
        <div>
          {new Intl.NumberFormat("en", { notation: "compact" }).format(
            record?.searchV1?.avgReelViews || 0
          )}
        </div>
      ),
    },
    {
      title: "Eng Rate",
      dataIndex: "searchV1.type",
      key: "name",
      render: (_: string, record: ICreator) => (
        <div>
          {new Intl.NumberFormat("en", { notation: "compact" }).format(
            record.searchV1?.engRate || 0
          )}{" "}
          %
        </div>
      ),
    },
    {
      title: "Type",
      dataIndex: "searchV1.type",
      key: "type",
      filterCount: type.length,
      filterDropdownProps: { destroyPopupOnHide: true },
      filterDropdown: ({ confirm, close }: { confirm: () => void; close: () => void }) => (
        <SearchMultiSelectFilter
          title="Type"
          confirm={confirm}
          close={close}
          searchPlaceholder="Search type"
          options={typeToDisplay.map((item) => ({ label: item, value: item }))}
          selectedValues={type}
          onApply={(value: string[]) => {
            handleTypeChange(value as InfluencerType[]);
          }}
        />
      ),
      render: (_: string, record: ICreator) => (
        <Tag color={"gray"}>{record?.searchV1?.type}</Tag>
      ),
    },

    {
      title: "Category",
      dataIndex: "searchV1?.category",
      key: "category",
      filterCount: category.length,
      filterDropdownProps: { destroyPopupOnHide: true },
      filterDropdown: ({ confirm, close }: { confirm: () => void; close: () => void }) => (
        <SearchMultiSelectFilter
          title="Category"
          confirm={confirm}
          close={close}
          searchPlaceholder="Search category"
          options={categoriesToDisplay.map((item) => ({ label: item, value: item }))}
          selectedValues={category}
          onApply={handleCategoryChange}
        />
      ),
      render: (_: string, record: ICreator) => (
        <div className={styles.grid}>
          {(record?.searchV1?.category || []).map((item: string) => (
            <Tag color={"gray"} style={{ width: "max-content" }}>
              {item}
            </Tag>
          ))}
        </div>
      ),
    },

    {
      title: "Rating",
      dataIndex: "searchV1.rating",
      key: "rating",
      width: 200,
      filterCount: rating ? 1 : 0,
      filterDropdownProps: { destroyPopupOnHide: true },
      filterDropdown: (props: { confirm: () => void; close: () => void }) => {
        const FilterDropdownContent = () => {
          const [tempRating, setTempRating] = useState<number>(rating || 0);

          useEffect(() => {
            setTempRating(rating || 0);
          }, [rating]);

          return (
            <ColumnFilterWrapper
              title="Rating"
              filterCount={tempRating ? 1 : 0}
              isFiltered={tempRating > 0}
              onReset={() => {
                setTempRating(0);
                handleRatingChange(undefined);
                props.confirm();
              }}
              onApply={() => {
                handleRatingChange(tempRating);
                props.confirm();
              }}
              onClose={props.close}
            >
              <div style={{ padding: "8px 4px", display: "flex", justifyContent: "center" }}>
                <Rate
                  allowHalf
                  value={tempRating}
                  onChange={(value) => setTempRating(value)}
                />
              </div>
            </ColumnFilterWrapper>
          );
        };

        return <FilterDropdownContent />;
      },
      render: (_: string, record: ICreator) => (
        <Rate allowHalf disabled value={record?.searchV1?.rating} />
      ),
    },
    {
      title: "Location",
      dataIndex: "searchV1.location",
      key: "location",
      // filterDropdown: ({ confirm, close }: { confirm: () => void; close: () => void }) => (
      //   <SearchMultiSelectFilter
      //     confirm={confirm}
      //     close={close}
      //     searchPlaceholder="Search location"
      //     options={locationToDisplay.map((item) => ({ label: item, value: item }))}
      //     selectedValues={location}
      //     onApply={handleLocationChange}
      //   />
      // ),
      render: (_location: any, record) => (
        <div className={styles.grid}>
          {(record?.searchV1?.location || []).map((item: string) => (
            <div>{item}</div>
          ))}
        </div>
      ),
    },
    // ...dynamicColumns,
  ];

  const toRender = useRef(0);

  useEffect(() => {
    const params = new URLSearchParams(searchParams);
    params.set("platform", JSON.stringify(platform));

    if (!backendFIlters || Object.keys(backendFIlters).length === 0) {
      params.delete("filters");
    } else {
      params.set("filters", JSON.stringify(backendFIlters));
    }

    if (toRender.current > 0) {
      setSearchParams(params);
      handleSearch();
    } else {
      toRender.current = toRender.current + 1;
    }
  }, [JSON.stringify(backendFIlters), platform, pageSize, bucketId]);

  useEffect(() => {
    // Read existing params from URL
    const filtersFromUrl = searchParams.get("filters");

    const usernameFromUrl = searchParams.get("username");
    const platform = searchParams.get("platform");
    // Parse values and update state
    if (filtersFromUrl) {
      setFiltersFromUrl(JSON.parse(filtersFromUrl));
    }

    if (usernameFromUrl) {
      setUsername(JSON.parse(usernameFromUrl));
      setFeUserName(JSON.parse(usernameFromUrl));
    }
    if (platform) setPlatform(JSON.parse(platform));
    return () => {
      reset();
    };
  }, [bucketId]);

  useEffect(() => {
    if (isLinked) {
      setPageNo(1);
      setPageSize(10);
      setFeUserName("");
      fullReset();
      fetchData(10, 1, bucketId);
    }
  }, [isLinked]);

  const handleSearch = () => {
    fetchData(pageSize, 1, bucketId);
    fetchFacets();
    setPageNo(1);
  };
  useEffect(() => {
    fetchData(pageSize, 1, bucketId);
    fetchFacets();
  }, [bucketId]);

  const platformsToDisplay = [
    ...(facets["platforms"] || []).map((item) => ({
      value: item._id,
      label: item._id,
    })),
    { value: "Others", label: "Others" },
  ];

  const handlePlatformChange = (newPlatform: string) => {
    reset();
    setPlatform(newPlatform);
  };

  const handleClearFilters = () => {
    Object.keys(selectedFilters).forEach((key) => {
      updateFilters(key, undefined);
    });
  };

  const handleRemoveFilter = (key: string) => {
    updateFilters(key, undefined);
  };

  return (
    <div style={{marginBottom: selectedCreators && selectedCreators?.length > 0 ? 70 : 0}}>
      <h1 className={styles.title}>Discover Onboarded Profiles</h1>
      <InfluencerSearchHeader
        title={isFromBuckePage ? (bucketName || "") : "Discover Onboarded Profiles"}
        isFromBucketPage={isFromBuckePage}
        feUsername={feUsername}
        setFeUserName={setFeUserName}
        platform={platform}
        setPlatform={handlePlatformChange}
        platformsToDisplay={platformsToDisplay}
        getFacetTitle={getFacetname}
        showAdvanced={showAdvanced}
        onToggleFilters={() => setShowAdvanced((prev) => !prev)}
        onClearFilters={handleClearFilters}
        onRemoveFilter={handleRemoveFilter}
        onSearchClick={saveFilters}
        TopEditButton={TopEditButton}
      />
      <div className={styles.contentContainer}>
        <div className={styles.tableSection}>
          <Table
            rowKey="_id"
            rowSelection={rowSelection}
            tableLayout="fixed"
            dataSource={data?.data}
            columns={columns}
            loading={isLoadingData}
            title={() => <TableTitleLayout 
              totalText={`${data?.pagination?.totalCount || 0} Records found`}
            />}
            onRow={(record) => ({
              style: { cursor: "pointer" },
            })}
            scroll={{
              x: "max-content"
            }}
            pagination={{
              current: paegNo,
              pageSize: pageSize,
              total: data?.pagination?.totalCount || 0,
              onChange: handlePaginationChange,
            }}
          />
        </div>
        {showAdvanced && (
          <div className={styles.filtersSidebar}>
            <InfluencerFilters isSidebar={true} />
          </div>
        )}
      </div>
      {/* <Drawer
        destroyOnClose
        title={"Influencer Details"}
        open={selectedInfluencer.visible}
        onClose={() => {
          setSelectedInfluencer({ visible: false, props: undefined });
        }}
        width={1300}
        footer={null}
      >
        {selectedInfluencer.props?.socialMediaDrawerId && (
          <SocialMediaInfluencerComp
            creatorInfo={{
              image: selectedInfluencer.props?.creatorInfo?.image,
              name: selectedInfluencer.props?.creatorInfo?.name,
              username: selectedInfluencer.props?.creatorInfo?.username,
            }}
            socialMediaInfluencerReq={{
              socialMediaObjectId:
                selectedInfluencer.props?.socialMediaDrawerId,
            }}
          />
        )}
      </Drawer> */}
      <Modal
        destroyOnClose
        title={"Suggest selected influencers in a campaign"}
        open={isSuggestModalOpen}
        onCancel={() => {
          setSuggestModalOpen(false);
        }}
        footer={null}
        width={1000}
      >
        <SuggestCampaignForm
          creators={selectedCreators || []}
          onClose={() => {
            setSelectedCreators && setSelectedCreators([]);
            setSuggestModalOpen(false);
          }}
        />
      </Modal>
      {selectedCreators && selectedCreators?.length > 0 ? createPortal(<Footer style={{
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1000,
                background: "white",
                padding: "16px 24px",
                boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.1)",
              }}>
                <Flex justify="space-between" align="center">
                  <div>
                    <b>{selectedCreators.length}</b> items selected
                  </div>
                <Flex gap={10} style={{overflow: "auto"}}>
        <ButtonComponent />
                {selectedCreators && selectedCreators?.length > 0 && (
                  <Button onClick={() => setSuggestModalOpen(true)}>
                    Suggest in a campaign
                  </Button>
                )}
                </Flex>
                </Flex>
      </Footer>, document.body) : null}
    </div>
  );
}
